// Pixels
export const spacing = {
  '0': 0, 'xs': 7, 's': 11, 'm': 16, 'l': 23, 'xl': 40, 'xxl': 74
}



// WEBPACK FOOTER //
// ./src/style/styled-components/settings/spacing.js